import { render, staticRenderFns } from "./Expiry.vue?vue&type=template&id=225a47fa"
import script from "./Expiry.vue?vue&type=script&lang=js"
export * from "./Expiry.vue?vue&type=script&lang=js"
import style0 from "./Expiry.vue?vue&type=style&index=0&id=225a47fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports